import React from "react";
import { Link } from "react-router-dom";
import "./BlogCategory.css"

const BlogCard = ({ title, desc, author, image }) => {
  const blogTitle = title ? title : "Title here";
  const blogDesc = desc ? desc : "Description of blog";
  const blogAuthor = author ? author : "Author";
  const blogImage = image
    ? image
    : `https://images.pexels.com/photos/414781/pexels-photo-414781.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260`;
  return (
    <div className="card h-100">
      <img src={blogImage} className="card-img-top h-100" alt="..." />
      <div className="card-body">
        <h5 className="card-title blog-card-title">{blogTitle}</h5>
        <p className="card-text text-responsive">{blogDesc}</p>

        <p className="mt-4">
          <Link to="/blogs/read" className="btn btn-outline-primary">
            Read more
          </Link>
         <span className="blog-card-author text-responsive"> By {blogAuthor}</span>
        </p>
      </div>
    </div>
  );
};

export default BlogCard;
